import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import * as S from "./styled";
import { Navigation } from "swiper/modules";
import { homeContentsLists } from "../../../data/home";
import Icon from "../../Icon";
import mainContentsArrowLeftIcon from "../../../assets/images/home/mainContentsArrowLeft.png";
import mainContentsArrowRightIcon from "../../../assets/images/home/mainContentsArrowRight.png";
import { NavLink } from "react-router-dom";
import { boardLists } from "../../../data/board";

const ContentsSlide = () => {
  const ContentsSlidePrevRef = useRef<HTMLButtonElement | null>(null);
  const ContentsSlideNextRef = useRef<HTMLButtonElement | null>(null);
  return (
    <S.ContentsSlideContainer
      data-aos="fade-up"
      data-aos-duration={1000}
      data-aos-easing="linear"
    >
      {boardLists.length > 3 && (
        <S.ContentsSlidPrevButton ref={ContentsSlidePrevRef}>
          <Icon>
            <img src={mainContentsArrowLeftIcon} alt="logo" />
          </Icon>
        </S.ContentsSlidPrevButton>
      )}
      <Swiper
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView={2} // 기본값
        breakpoints={{
          900: { slidesPerView: 3, spaceBetween: 30 },
          500: { slidesPerView: 2, spaceBetween: 20 },
        }}
        observer={true} // 변경 감지
        observeParents={true} // 부모 요소 변경 감지
        resizeObserver={true} // 브라우저 크기 변경 감지
        navigation={{
          prevEl: ContentsSlidePrevRef.current,
          nextEl: ContentsSlideNextRef.current,
        }}
        onSwiper={(swiper: any) => {
          setTimeout(() => {
            if (swiper?.params?.navigation) {
              Object.assign(swiper.params.navigation, {
                prevEl: ContentsSlidePrevRef.current,
                nextEl: ContentsSlideNextRef.current,
              });
              swiper.navigation.init();
              swiper.navigation.update();
            }
          });
        }}
      >
        {boardLists.map((homeContent, index) => (
          <SwiperSlide key={index}>
            <NavLink to={`/board/${homeContent.id}`}>
              <S.HomeContentsSlideWrapper>
                <S.HomeContentsSlideImgWrap>
                  <img src={homeContent.images[0]} alt={homeContent.title} />
                </S.HomeContentsSlideImgWrap>
                <S.HomeContentsSlideTextWrapper>
                  <S.HomeContentsSlideTextWrap>
                    <div className="title-wrap">
                      <h6>{homeContent.title}</h6>
                      <p>{homeContent.listText}</p>
                      <span>{homeContent.date}</span>
                    </div>
                  </S.HomeContentsSlideTextWrap>
                </S.HomeContentsSlideTextWrapper>
              </S.HomeContentsSlideWrapper>
            </NavLink>
          </SwiperSlide>
        ))}
      </Swiper>

      {boardLists.length > 3 && (
        <S.ContentsSlidNextButton ref={ContentsSlideNextRef}>
          <Icon>
            <img src={mainContentsArrowRightIcon} alt="logo" />
          </Icon>
        </S.ContentsSlidNextButton>
      )}

      <S.ViewMoreButton>
        <NavLink to="/board">더보기</NavLink>
      </S.ViewMoreButton>
    </S.ContentsSlideContainer>
  );
};

export default ContentsSlide;
